import { PageHeader, Section, Empty } from '@/shared/ui';
import type { ModuleDef } from '@/entities/tenant';

/** Trang tạm cho module chưa chuyển sang nền tảng mới. */
export function ModulePendingPage({ module }: { module: ModuleDef }) {
  return (
    <>
      <PageHeader title={module.label} />
      <Section>
        <Empty title="Đang triển khai trên nền tảng mới">
          Module {module.label} sẽ sẵn sàng sau khi dịch vụ {module.service ?? 'tương ứng'} được nối vào cổng API.
        </Empty>
      </Section>
    </>
  );
}
